export enum EVideoSource {
  fr_academy, // 帆软学院
  self_upload, // 自己上传
}

export enum EVideoUploadStatus {
  loading,
  success,
  fail,
}

export type TVideNode = {
  id: string;
  name: string;
  url?: string;
  source: EVideoSource;
  duration?: number;
  index: number;
  uploadStatus?: EVideoUploadStatus;
  uploadPercentage?: number;
  size?: number;
  resolution?: string;
};
